"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpirationInHoursForCombo = exports.getExpirationDateForCombo = void 0;
const constants_1 = require("@daytrip/constants");
const PERSONAL_COMBO_EXPIRATION_TRERESHOLD_HOURS = [
    { minHours: -5 * constants_1.DAY_IN_HOURS, maxHours: constants_1.DAY_IN_HOURS, expirationHours: 1 },
    { minHours: constants_1.DAY_IN_HOURS, maxHours: 3 * constants_1.DAY_IN_HOURS, expirationHours: 1 },
    { minHours: 3 * constants_1.DAY_IN_HOURS, maxHours: 7 * constants_1.DAY_IN_HOURS, expirationHours: 3 },
    { minHours: 7 * constants_1.DAY_IN_HOURS, maxHours: 21 * constants_1.DAY_IN_HOURS, expirationHours: 3 },
    { minHours: 21 * constants_1.DAY_IN_HOURS, maxHours: 90 * constants_1.DAY_IN_HOURS, expirationHours: 24 },
];
const CLEAN_COMBO_EXPIRATION_TRERESHOLD_HOURS = [
    { minHours: -5 * constants_1.DAY_IN_HOURS, maxHours: constants_1.DAY_IN_HOURS, expirationHours: 1 },
    { minHours: constants_1.DAY_IN_HOURS, maxHours: 3 * constants_1.DAY_IN_HOURS, expirationHours: 1 },
    { minHours: 3 * constants_1.DAY_IN_HOURS, maxHours: 7 * constants_1.DAY_IN_HOURS, expirationHours: 3 },
    { minHours: 7 * constants_1.DAY_IN_HOURS, maxHours: 21 * constants_1.DAY_IN_HOURS, expirationHours: 3 },
    { minHours: 21 * constants_1.DAY_IN_HOURS, maxHours: 90 * constants_1.DAY_IN_HOURS, expirationHours: 24 },
];
const getExpirationDateForCombo = (options) => {
    return getExpirationDataForCombo(options).expirationDate;
};
exports.getExpirationDateForCombo = getExpirationDateForCombo;
const getExpirationInHoursForCombo = (options) => {
    return getExpirationDataForCombo(options).expirationInHours;
};
exports.getExpirationInHoursForCombo = getExpirationInHoursForCombo;
function getExpirationDataForCombo({ isPersonal, departureAtUtc, }) {
    const nowMs = new Date().getTime();
    const departureAtMs = new Date(departureAtUtc).getTime();
    const hoursToDeparture = (departureAtMs - nowMs) / constants_1.HOUR_IN_MILLISECONDS;
    const tresholds = isPersonal ? PERSONAL_COMBO_EXPIRATION_TRERESHOLD_HOURS : CLEAN_COMBO_EXPIRATION_TRERESHOLD_HOURS;
    const treshold = tresholds.find((t) => t.minHours <= hoursToDeparture && hoursToDeparture < t.maxHours);
    const expirationInHours = treshold ? treshold.expirationHours : 24;
    const expirationDate = new Date(nowMs + expirationInHours * constants_1.HOUR_IN_MILLISECONDS);
    return { expirationDate, expirationInHours };
}
//# sourceMappingURL=getExpirationDateForCombo.js.map